import React from 'react';
import { Layout, Seo } from '@layout';
import {
  AboutUsHero,
  OurStory,
  DiversityAndInclusion,
  AboutFeaturedSection,
  FooterHeroSection,
  PhotoCollectionSection,
} from '@sections/about';
import { aboutPageData } from '@data-ts/pages/about';

const guestPhotos = [
  'about-us/product-squares-9.svg',
  'about-us/product-squares-8.svg',
  'about-us/product-squares-10.svg',
  'about-us/product-squares-11.svg',
  'about-us/product-squares-1.svg',
  'about-us/product-squares-5.png',
  'about-us/product-squares-6.svg',
  'about-us/product-squares-2.svg',
  'about-us/product-squares-7.svg',
  'about-us/product-squares-4.svg',
  'about-us/product-squares-3.png',
];

const AboutUs = () => {
  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="mono7"
      transparentHeaderButtonVariant="yellowPrimary"
      transparentHeaderLinkVariant="alternative"
    >
      <Seo title={aboutPageData.seo.title} description={aboutPageData.seo.content} canonicalURL={'https://withjoy.com/about/'} />
      <AboutUsHero />
      <OurStory />
      <DiversityAndInclusion />
      <PhotoCollectionSection photos={guestPhotos} />
      <AboutFeaturedSection />
      <FooterHeroSection />
    </Layout>
  );
};

export default AboutUs;
